// extracted by mini-css-extract-plugin
export default {"tabs":"s_b0","tab-list":"s_b1","tab":"s_b2","active":"s_b3"};